import { Outlet } from "react-router-dom";

import { BASE_ROUTES } from "@monorepo/app-pages";

import { Main } from "@/pages/Main";

import type { FC } from "react";
import type { RouteObject } from "react-router-dom";

const RootLayout: FC = () => <Outlet />;

export const routes: RouteObject[] = [
    {
        path: "/",
        element: <RootLayout />,
        children: [
            {
                index: true,
                element: <Main />,
            },
        ],
    },
    ...BASE_ROUTES,
];
